import { GLOBAL_LOCALES } from '@repo/gatsby-localization-helpers';
import type { GetInternalLinkFunctionType, InternalLink } from '@repo/models/GetInternalLinkFunctionType';

interface TopLevelMenuItemLink {
  href?: string;
  linkType?: string;
  internalLink?: InternalLink;
}

const getHomepageHrefs = (): Set<string> => {
  const hrefs = new Set<string>(['/']);

  Object.values(GLOBAL_LOCALES).forEach(locale => {
    if (locale.urlPath) {
      const path = locale.urlPath.trim();
      if (path) {
        hrefs.add(`/${path}`);
        hrefs.add(`/${path}/`);
      }
    }
  });

  return hrefs;
};

const HOMEPAGE_HREFS = getHomepageHrefs();

const isHomepageFallbackHref = (href: string) => HOMEPAGE_HREFS.has(href);

// Resolves the destination for a header menu item link: an internal link via
// getInternalLink, or an external href. Returns undefined when there is no link.
const getTopLevelMenuItemLink = (
  link: TopLevelMenuItemLink | undefined,
  getInternalLink: GetInternalLinkFunctionType
): string | undefined => {
  if (link?.linkType === 'disable') return undefined;
  if (link?.internalLink)
    return getInternalLink({ ...link, reference: link.internalLink });
  if (link?.href) return link.href;
  return undefined;
};

// For crawlable menu triggers
export const getCrawlableTopLevelMenuItemLink = (
  link: TopLevelMenuItemLink | undefined,
  getInternalLink: GetInternalLinkFunctionType
): string | undefined => {
  const href = getTopLevelMenuItemLink(link, getInternalLink);
  if (!href || isHomepageFallbackHref(href)) return undefined;
  return href;
};

export default getTopLevelMenuItemLink;
